import { Button, Form, Input, Modal, ModalProps, notification, Typography } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { useEffect } from 'react';
import { referralCodeIAO } from 'src/helpers/storage';
import { useAppTranslation } from 'src/i18n/hooks';
import { useCheckRefCode } from 'src/services/user/check-ref-code';

type AccessCodeModalProps = Pick<ModalProps, 'open' | 'onClose' | 'onOk'>;

export const AccessCodeModal = ({ open, onClose, onOk }: AccessCodeModalProps) => {
  const [form] = Form.useForm();
  const { mutate: checkRefCode, isPending } = useCheckRefCode();
  const { t } = useAppTranslation('common');
  const searchParams = new URLSearchParams(window.location.search);
  const referralCode = searchParams.get('referral');

  useEffect(() => {
    if (referralCode) {
      form.setFieldValue('code', referralCode);
    }
  }, [referralCode]);

  const closeModal = async (e: React.SyntheticEvent<Element, Event>) => {
    const enteredValue = form.getFieldValue('code');

    await checkRefCode(
      { referral_code: enteredValue },
      {
        onSuccess: (data) => {
          localStorage.setItem(referralCodeIAO, enteredValue);
          onClose!(e);
          notification.success({
            message: t('accessCodeModal.successMessage'),
            description: t('accessCodeModal.successDescription'),
            placement: 'bottomRight',
            style: { fontFamily: 'Poppins' },
          });
        },
        onError: (error) => {
          notification.error({
            message: t('accessCodeModal.errorMessage'),
            description: t('accessCodeModal.errorDescription'),
            placement: 'bottomRight',
            style: { fontFamily: 'Poppins' },
          });
        },
      },
    );
  };

  return (
    <Modal
      className="position-tab-modal"
      centered
      title={t('accessCodeModal.title')}
      open={open}
      footer={false}
      onClose={onClose}
      onCancel={onClose}
      styles={{
        mask: {
          backgroundImage: "url('/images/dex-bg.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        },
        wrapper: {
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          zIndex: 2147483647,
        },
      }}
    >
      <Form layout="vertical" form={form} onFinish={closeModal} initialValues={{ code: '' }}>
        <Typography.Paragraph>
          {' '}
          {t('accessCodeModal.description')}
        </Typography.Paragraph>
        <FormItem name="code">
          <Input
            styles={{ input: { textAlign: 'end' } }}
            size="large"
            style={{ textAlign: 'end' }}
            prefix={t('accessCodeModal.inputPlaceholder')}
            onChange={(e) => form.setFieldValue('code', e.target.value)}
          />
          <div className="flex justify-end mt-[10px] ">
            <button
              className="text-[#1890ff]"
              type="button"
              onClick={(e) => {
                onOk?.(e);
              }}
            >
              {t('accessCodeModal.howToGetCode')}
            </button>
          </div>
        </FormItem>
        <Button block htmlType="submit" size="large" type="primary">
          {t('accessCodeModal.confirm')}
        </Button>
      </Form>
    </Modal>
  );
};
